import { ISignalTimeRecording } from "@types"
import { protectedApi } from "store/Api"

const actionsSignalTimeRecording = protectedApi.injectEndpoints({

    endpoints: (builder) => ({
        actionsSignalTimeRecording: builder.query<ISignalTimeRecording[], void>({
            query: () => {
                return {
                    method: "GET",
                    url: `actions/signal_time_recording`,
                }
            },
        }),
    }),

})

export const { useActionsSignalTimeRecordingQuery } = actionsSignalTimeRecording
